import { useEffect, useRef, useState } from 'react'
import { pickOldestNonCompleteMonth, type MonthSelectOption } from '@/utils/allocationFormat'

/** Pick the oldest non-complete month once after `ready`; never auto-repick afterward. */
export function useDefaultIncompleteReportMonth(
  options: MonthSelectOption[],
  ready: boolean,
): [string | null, (month: string | null) => void] {
  const [selectedMonth, setSelectedMonth] = useState<string | null>(null)
  const initializedRef = useRef(false)

  useEffect(() => {
    if (!ready || initializedRef.current) return

    initializedRef.current = true
    if (options.length === 0) {
      setSelectedMonth(null)
      return
    }

    setSelectedMonth(pickOldestNonCompleteMonth(options))
  }, [ready, options])

  return [selectedMonth, setSelectedMonth]
}
